import { PlayerSdk } from "@api.video/player-sdk";
import { isHttpUrl } from "@memorang/helpers/url";
import { useEffect, useRef } from "react";

export const VideoPlayer = ({
	videoUrl,
	maxWidth = 480,
	height = 200,
}: {
	videoUrl: string;
	maxWidth?: number;
	height?: number;
}) => {
	const playerRef = useRef(null);
	const isDirectUrl = isHttpUrl(videoUrl);

	useEffect(() => {
		if (playerRef.current && !isDirectUrl) {
			new PlayerSdk(playerRef.current, {
				id: videoUrl,
				hideTitle: true,
			});
		}
	}, [videoUrl, isDirectUrl]);

	if (isDirectUrl) {
		return (
			// biome-ignore lint/a11y/useMediaCaption: source video has no caption track
			<video
				src={videoUrl}
				controls
				style={{
					maxWidth,
					height,
					border: "1px solid",
				}}
			/>
		);
	}

	return (
		<div
			ref={playerRef}
			style={{
				maxWidth,
				height,
			}}
		/>
	);
};
